import { FC, PropsWithChildren } from "react";
import styled from "styled-components";
import { color as YuColours, fonts } from "../../styles";

interface PillSectionProps {
  color?: string;
  isInverted?: boolean;
  isCentered?: boolean;
  pt?: string;
  pb?: string;
}

export const PillSection: FC<PropsWithChildren<PillSectionProps>> = ({
  color = YuColours.B1100,
  isInverted,
  children,
  isCentered,
  pt,
  pb,
}) => (
  <Wrapper pt={pt} $isCentered={isCentered} color={isInverted ? YuColours.white : color} pb={pb}>
    {children}
  </Wrapper>
);

const Wrapper = styled.div<{ color?: string; $isCentered?: boolean; pt?: string; pb?: string }>`
  display: flex;
  flex-wrap: wrap;
  column-gap: 1rem;
  row-gap: 0.75rem;
  font-family: ${fonts.body};
  font-size: 0.875rem;
  line-height: 1.5rem;
  letter-spacing: 0.075rem;
  color: ${(p) => p.color || YuColours.B1100};
  justify-content: ${(p) => (p.$isCentered ? "center" : "start")};
  padding-top: ${(p) => p.pt || 0};
  padding-bottom: ${(p) => p.pb || 0};
`;
